import React from 'react';

export function Liechtenstein(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 0H513V171H0V0Z" fill="#002B7F"/>
      <path d="M0 171H513V342H0V171Z" fill="#CE1126"/>
      <path d="M40,90 L55,65 L70,90 L65,115 L55,120 L45,115Z" fill="#FFD700"/>
    </svg>
  );
}
